<div class="store-dt-popup">
<h5>Add Category</h5>
  <form [formGroup] = "createCategoryForm">
    <ul class="store-listing-dt">
      <li>
        <h6>Name<span style="color:red">*</span></h6>
        <div class="store-pop-right">
          <mat-form-field class="drg-to-top">
            <input matInput class="example-right-align" formControlName="CategoryName">
            <mat-error *ngIf="!f.CategoryName.valid && f.CategoryName.touched && (f.CategoryName.pristine || f.CategoryName.dirty)">
              <strong>Required</strong>
           </mat-error>
          </mat-form-field>
        </div>
      </li>
      <li>
        <h6>Description<span style="color:red">*</span></h6>
        <div class="store-pop-right">
          <mat-form-field>
            <!-- <input matInput  formControlName="Description"> -->
            <textarea matInput class="example-right-align" placeholder="Description" #message maxlength="500" formControlName="Description"></textarea>
            <mat-hint align="end">{{message.value.length}} / 500</mat-hint>
            <mat-error *ngIf="!f.Description.valid && f.Description.touched && (f.Description.pristine || f.Description.dirty)">
              <strong>Required</strong>
           </mat-error>
          </mat-form-field>
        </div>
      </li>
    </ul>
    <div class="store-dt-popup-ftr">
      <button class="pro-btn1" mat-button (click)="fn_Cancel()">Cancel</button>
      <button class="pro-btn1" mat-button [disabled] = "createCategoryForm.invalid" (click)="fn_CreateCategory(createCategoryForm)">Submit</button>
    </div>
  </form>
</div>
